import React from 'react';

// Marks a subtree as "storefront image fields live here". Any ImageUploader /
// StorefrontBannerImageUploader rendered underneath a provider switches from the legacy
// upload-only behaviour to the asset library (pick an existing asset or upload a new one, both
// registered as storefront assets). Outside a provider (product segments, categories, anything
// non-storefront) the uploaders behave exactly as they always have.
export interface IAssetSource {
    // Scope new uploads and the picker's "This storefront" filter are keyed on. May be `global`
    // (see STOREFRONT_ASSET_GLOBAL) for org-wide screens such as Global Appearance.
    storefrontId: string;
}

const AssetSourceContext = React.createContext<IAssetSource | undefined>(undefined);

export const AssetSourceProvider = AssetSourceContext.Provider;

// `undefined` when there is no provider above, which is the signal to keep legacy behaviour.
export const useAssetSource = (): IAssetSource | undefined => React.useContext(AssetSourceContext);

export default AssetSourceContext;
